import { LoadComponent } from "@loadComponent";
import VerticalLayout from '_layout/Vertical';
import CourtEmployee from "_pages/administrative/court-employees";
import Judges from "_pages/administrative/judges";
import Users from "_pages/administrative/users";
import ClientLayout from '_pages/client';
import ConferenceDesk from "_pages/client/conference-desk";
import ClientDesk from '_pages/client/desk';
import ClientHearing from '_pages/client/hearing';
import HearingSearch from '_pages/client/hearing-search';
import Home from '_pages/client/home';
import Assignments from "_pages/params/assignments";
import ConferencesDesk from "_pages/params/conference-desk";
import Counties from "_pages/params/counties";
import Courts from "_pages/params/courts";
import Desk from "_pages/params/desk";
import Regionals from "_pages/params/regionals";
import Roles from "_pages/params/roles";
import Calendar from "_pages/service/calendar";
import Conference from "_pages/service/conference";
import Hearing from "_pages/service/hearing";
import Queue from "_pages/service/queue";
import { lazy } from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import * as layoutConstants from "../constants/layout";
import { useRedux } from "../hooks";
import { changeSidebarTheme, toggleSidebarUserInfo } from "../redux/layout/actions";
import PrivateRoute from './PrivateRoute';
import Error404 from "_pages/other/Error404";
import Reports from "_pages/audit/reports";
import Profile from "_pages/profile";
import ConferenceCalendar from "_pages/service/conference-calendar";
import ChatBot from "_pages/audit/chatbot";
import Logs from "_pages/audit/logs";


const Routes = () => {
    const { dispatch } = useRedux();

    dispatch(changeSidebarTheme(layoutConstants.SideBarTheme.LEFT_SIDEBAR_THEME_BRAND));
    dispatch(toggleSidebarUserInfo(false));

    return useRoutes([
        {
            path: '',
            element: <ClientLayout />,
            children: [
                {
                    path: '',
                    element: <Navigate to="inicio" />
                },
                {
                    path: 'agendamento/*',
                    element: <ConferenceDesk />
                },
                {
                    path: 'audiencia/*',
                    element: <ClientHearing />
                },
                {
                    path: 'balcao/*',
                    element: <ClientDesk />
                },
                {
                    path: 'busca/*',
                    element: <HearingSearch />
                },
                {
                    path: 'inicio/*',
                    element: <Home />
                },
                {
                    path: 'protocolo-agendamento/*',
                    element: <LoadComponent component={lazy(() => import('_pages/client/conference'))} />
                },
                {
                    path: '*',
                    element: <h1>404</h1>,
                }
            ],
        },

        {
            path: 'admin',
            element: <Outlet />,
            children: [
                { path: 'login', element: <LoadComponent component={lazy(() => import('../pages/auth/Login'))} /> },
                { path: 'court-select', element: <LoadComponent component={lazy(() => import('../pages/auth/CourtSelect'))} /> },
                { path: 'two-factor', element: <LoadComponent component={lazy(() => import('../pages/auth/TwoFactor'))} /> },
                { path: 'confirm', element: <LoadComponent component={lazy(() => import('../pages/auth/Confirm'))} /> },
                { path: 'forget-password', element: <LoadComponent component={lazy(() => import('../pages/auth/ForgetPassword'))} /> },
                { path: 'reset-password', element: <LoadComponent component={lazy(() => import('../pages/auth/ResetPassword'))} /> },
                { path: 'logout', element: <LoadComponent component={lazy(() => import('../pages/auth/Logout'))} /> },
                {
                    path: '',
                    element: <PrivateRoute component={VerticalLayout} />,
                    children: [
                        {
                            path: '',
                            element: <Navigate to="dashboard" />
                        },
                        // [A]
                        {
                            path: 'audit',
                            children: [
                                {
                                    path: 'reports/*',
                                    element: <Reports />,
                                },
                                {
                                    path: 'chatbot/*',
                                    element: <ChatBot />,
                                },
                                {
                                    path: 'logs/*',
                                    element: <Logs />,
                                },
                            ]
                        },
                        {
                            path: 'administrative',
                            children: [
                                {
                                    path: 'court-employees/*',
                                    element: <CourtEmployee />
                                },
                                {
                                    path: 'judges/*',
                                    element: <Judges />
                                },
                                {
                                    path: 'users/*',
                                    element: <Users />,
                                },
                            ]
                        },
                        // [D]
                        {
                            path: 'dashboard',
                            element: <LoadComponent component={lazy(() => import('_pages/dashboards/main/'))} />,
                        },
                        // [P]
                        {
                            path: 'params',
                            children: [
                                {
                                    path: 'conference-desks/*',
                                    element: <ConferencesDesk />
                                },
                                {
                                    path: 'regionals/*',
                                    element: <Regionals />,
                                },
                                {
                                    path: 'counties/*',
                                    element: <Counties />,
                                },
                                {
                                    path: 'courts/*',
                                    element: <Courts />,
                                },
                                {
                                    path: 'assignments/*',
                                    element: <Assignments />,
                                },
                                {
                                    path: 'roles/*',
                                    element: <Roles />,
                                },
                            ]
                        },
                        {
                            path: 'profile',
                            element: <LoadComponent component={Profile} />,
                        },
                        // [S]
                        {
                            path: 'service',
                            children: [
                                {
                                    path: 'calendar/*',
                                    element: <Calendar />,
                                },
                                {
                                    path: 'conference-calendar/*',
                                    element: <ConferenceCalendar />,
                                },
                                {
                                    path: 'hearings/*',
                                    element: <Hearing />,
                                },
                                {
                                    path: 'desks/*',
                                    element: <Desk />
                                },
                                {
                                    path: 'conference/*',
                                    element: <Conference />
                                },
                                {
                                    path: 'queue/*',
                                    element: <Queue />,
                                }
                            ]
                        },
                        {
                            path: '*',
                            element: <LoadComponent component={Error404} />,
                        }
                    ]
                },
            ]
        }
    ]);

};

export default Routes;
